// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"3bd59ad9","64":"8e8c7fdd","419":"971005e5","720":"633b1b28","774":"0a2a345a","778":"7fb0f6bd","883":"4620ba9f","977":"147fce79"}[chunkId] + ".chunk.js";
};